<template>
  <div>
    <Breadcrumb :options="breadcrumb" />

    <SearchField :form="formInline" :formCtrl="formCtrl" @onSearch="onSearch" @onReset="onReset"></SearchField>

    <Table ref="table" :tableData="tableData" :cols="cols" :page="page" :limit="limit" :total="total" :showIndex="true"
      @onSelectionChange="onSelectionChange" @onCurrentChange="onCurrentChange" @onSizeChange="onSizeChange" />
  </div>
</template>

<script>
import tableMixin from "../../mixin/table";

export default {
  name: "SystemLoginLog",
  mixins: [tableMixin],
  data() {
    return {
      baseUrl: 'log',
      breadcrumb: [
        { name: "系统设置" },
        { name: "登录日志" },
      ],
      formInline: {},
      formCtrl: [
        {
          label: "用户名",
          keyName: "username",
          placeholder: "请填写用户名",
          type: "text",
        },
        // {
        //   label: "昵称：",
        //   keyName: "nickname",
        //   placeholder: "请填写昵称",
        //   type: "text",
        // },
        {
          label: "登录状态",
          keyName: "success",
          type: "select",
          options: [
            { label: '登录成功', value: 1 },
            { label: '登录失败', value: 2 },
          ],
        },
      ],
      cols: [
        { prop: "username", label: "用户名"},
        { prop: "nickname", label: "姓名"},
        { prop: "ip", label: "登录方式" },
        { prop: "created", label: "登录时间"},
        { prop: "status", label: "登录状态"},
      ],
    };
  },
  methods: {
    tableDataHandler({ count, data }) {
      this.total = count
      if (data && data.length) {
        this.tableData = data.map(v => {
          const obj = { ...v }
          obj.status = v.success == 1 ? '登录成功' : '登录失败'
          return obj
        })
      }
    },
  },
};
</script>
